import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link
          to="/"
          className="inline-flex items-center text-orange-500 hover:text-orange-600 mb-8"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Home
        </Link>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="flex justify-between items-start mb-6">
            <h1 className="text-2xl font-bold">Privacy Policy</h1>
            <p className="text-gray-600 text-sm">
              Last updated: April 03, 2024
            </p>
          </div>

          <div className="prose max-w-none text-sm">
            <h2 className="font-bold text-base mb-4">Introduction</h2>
            <p className="mb-6">
              We, strikeaprice.com, understand the importance of protecting your
              personal information and respecting your privacy. This Privacy
              Policy explains how we collect, store, and use the information you
              provide to us when using our software products and services.
            </p>

            <h2 className="font-bold text-base mb-4">
              Collection of Personal Information
            </h2>
            <p className="mb-6">
              We collect personal information that you provide to us when you
              create an account, sign up for a newsletter, or contact us for
              support. This information may include your name, email address,
              phone number, and other relevant details.
            </p>

            <h2 className="font-bold text-base mb-4">
              Use of Personal Information
            </h2>
            <p className="mb-4">
              We use the collected personal information to provide you with the
              software products and services you request. This includes:
            </p>
            <ul className="mb-6 ml-6 list-disc">
              <li>
                Ensuring that you can access and use the software products and
                services.
              </li>
              <li>
                Providing you with updates, support, and other services related
                to the software products and services.
              </li>
              <li>
                Enhancing and personalizing your experience with our software
                products and services.
              </li>
              <li>
                Communicating with you about our software products and services,
                as well as other information that may be relevant to you.
              </li>
            </ul>

            <h2 className="font-bold text-base mb-4">
              Sharing Personal Information
            </h2>
            <p className="mb-4">
              We do not share your personal information with third parties,
              except in the following circumstances:
            </p>
            <ul className="mb-6 ml-6 list-disc">
              <li>
                We may share your personal information with our service
                providers and partners who help us deliver our software products
                and services. However, we will only share the information
                necessary for them to perform their services and are bound by
                contract to protect your personal information.
              </li>
              <li>
                We may disclose your personal information if required by law or
                if we have a good faith belief that such action is necessary to
                comply with a legal obligation or to protect our rights or the
                rights of others.
              </li>
            </ul>

            <h2 className="font-bold text-base mb-4">Security Measures</h2>
            <p className="mb-6">
              We implement various security measures to protect your personal
              information from unauthorized access, disclosure, or use. These
              measures include encryption, secure data storage, and access
              controls. However, no method of transmission over the internet or
              electronic storage is completely secure, so we cannot guarantee
              its absolute security.
            </p>

            <h2 className="font-bold text-base mb-4">Rights and Choices</h2>
            <p className="mb-6">
              You have the right to access, correct, or delete your personal
              information. You can exercise these rights by contacting us at{" "}
              <a
                href="mailto:support@strikeaprice.com"
                className="text-orange-500 hover:underline"
              >
                support@strikeaprice.com
              </a>
              . We will respond to your request within a reasonable timeframe.
            </p>

            <h2 className="font-bold text-base mb-4">
              Changes to Privacy Policy
            </h2>
            <p className="mb-6">
              We may update this Privacy Policy from time to time to reflect
              changes in our practices or for other operational, legal, or
              regulatory reasons. When we make changes, we will update the "Last
              Updated" date at the bottom of the Privacy Policy. We encourage
              you to review the Privacy Policy periodically to stay informed
              about our privacy practices.
            </p>

            <h2 className="font-bold text-base mb-4">Contact Information</h2>
            <p className="mb-6">
              If you have any questions or concerns about this Privacy Policy,
              please contact us at{" "}
              <a
                href="mailto:support@strikeaprice.com"
                className="text-orange-500 hover:underline"
              >
                support@strikeaprice.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
